// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.addIcon[data-v-dadbc8d6] {\n  position: absolute !important;\n  right: 0 !important;\n  top: -3px !important;\n}\n.accent--hover[data-v-dadbc8d6]:hover {\n  color: #44d3af;\n}\n", ""]);
// Exports
module.exports = exports;
